// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8e1a5c43","455":"aca7963f"}[chunkId] + ".chunk.js";
};